<template lang="pug">
  el-dialog(
    width="35%"
    title="Change Password"
    :visible.sync="dialogVisible"
    :showClose="false"
  )
    el-form(
      :model="userProfile"
      :rules="rules"
      label-width="120px"
      label-position="left"
      ref="userprofile"
      style="padding: 0px 15px; overflow: auto;"
    )
      el-form-item(label="Password" prop="newpassword")
        el-input(
          v-model="userProfile.newpassword"
          placeholder="New password"
          type="password"
        )

      el-form-item(label="New Password" prop="confirmpassword")
        el-input(
          v-model="userProfile.confirmpassword"
          placeholder="Confirm new password"
          type="password"
        )

    div(slot="footer")
      el-button(type="primary" @click.stop="onCancel" plain) Cancel
      el-button(type="primary" @click.stop="onSubmit('userprofile')" :loading="submitting") Save New Password
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'ChangePasswordModal',

    props: {
      show: {
        type: Boolean,
        default: false,
      },
      accessToken: {
        type: String,
        default: '',
      },
    },

    computed: {
      dialogVisible: {
        get() {
          return this.show
        },

        set(value) {
          if (value === false) {
            this.$emit('closeDialog')
            this.resetData()
          }
        },
      },
    },

    data() {
      return {
        submitting: false,
        userProfile: {
          newpassword: '',
          confirmpassword: '',
        },

        rules: {
          newpassword: [
            { required: true, message: 'Please input your new password', trigger: 'blur' },
            { min: 8, message: 'Length should be at least 8.', trigger: 'blur' },
          ],
          confirmpassword: [
            {
              required: true,
              validator: this.validatePasswords,
              trigger: 'blur',
            },
          ],
        },
      }
    },

    methods: {
      validatePasswords(rule, value, callback) {
        let errors = ''
        if (rule.required !== undefined) {
          if (value === '' && this.userProfile.newpassword !== '') {
            errors += 'Please re-enter your new password. '
          }
        }

        if (value !== '' && value !== this.userProfile.newpassword) {
          errors += 'Passwords do not match.'
        }

        if (errors !== '') {
          callback(new Error(errors))
        } else {
          callback()
        }
      },

      onSubmit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submitting = true
            const config = {
              method: 'post',
              url: '/reset',
              data: { password: this.userProfile.newpassword },
            }
            if (this.accessToken) {
              config.headers = { Authorization: `Bearer ${this.accessToken}` }
            }
            axios(config)
              .then(() => {
                this.submitting = false
                this.onCancel()
                this.$notify.success({
                  title: 'Password Changed!',
                  message: 'Your new password has been saved.',
                  position: 'bottom-right',
                })
              })
              .catch(() => {
                this.submitting = false
                this.$notify.error({
                  title: 'Error',
                  message: 'Your new password has not been saved.',
                  position: 'bottom-right',
                })
              })
          }

          return false
        })
      },

      onCancel() {
        this.dialogVisible = false
        this.submitting = false
        this.resetData()
      },

      resetData() {
        Object.keys(this.userProfile).forEach((item) => {
          this.userProfile[item] = ''
        })
      },
    },
  }
</script>

<style module>
  .formProfile {
    width: 460px; 
    margin: auto;
    min-height: 350px;
    overflow: auto;

    label {
      font-family: Arial, Helvetica, sans-serif;
      font-size: 14px;
      font-weight: bold;
      color: #757575;
    }    
  }  
</style>





// WEBPACK FOOTER //
// client/components/ChangePasswordModal/ChangePasswordModal.vue